import {MDIntent} from '@mintdata-wsp/common/components/MDIntent';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {DialogButton} from '@mintdata-wsp/wsp/ui/components/forms/DialogButton';
import {ErrorPopupSide, Input, InputStyle} from '@mintdata-wsp/wsp/ui/components/forms/Input';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ButtonStyle} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import {bind} from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./RenameDialog.less');
const cx = classnames.bind(styles);

export interface IRenameDialogProps
{
    title:string;
    bodyText?:string;
    defaultName:string;
    placeholder?:string;
    isNameValidFn?:(name:string) => boolean;
    getErrorMessageFn?:(name:string) => string;
    onSave:(name:string) => void;
    onClose?:() => void;
    onNameChange?:(name:string) => void;
    onInputRef?:(ref:Input | null) => void;
}

@observer
export class RenameDialog extends React.Component<IRenameDialogProps, any>
{
    @observable
    private _name:string = null;

    public defaultProps:Partial<IRenameDialogProps> = {
        bodyText: '',
        placeholder: ''
    };

    public constructor(props:IRenameDialogProps)
    {
        super(props);

        this._name = this.props.defaultName;
    }

    @bind
    private async _handleSave():Promise<void>
    {
        if( !this._isValidFn(this._name) )
            return;

        this.props.onSave(this._name);
    }

    @bind
    private _handleClose():void
    {
        controllers.ui.dialogs.hideDialog(Dialogs.Rename);

        if( this.props.onClose )
            this.props.onClose();
    }

    @bind
    private _isValidFn(value:string):boolean
    {
        if( this.props.isNameValidFn )
            return this.props.isNameValidFn(value);

        return true;
    }

    @bind
    private _getErrorMessageFn(value:string):string
    {
        if( this.props.getErrorMessageFn )
            return this.props.getErrorMessageFn(value);

        return '';
    }

    @action.bound
    private _handleNameChange(name:string):void
    {
        this._name = name;

        if( this.props.onNameChange )
            this.props.onNameChange(name);
    }

    @bind
    private _handleInputRef(ref:Input | null):void
    {
        if( this.props.onInputRef )
            this.props.onInputRef(ref);
    }

    @bind
    _onCancelled()
    {
        this._handleClose();
    }

    public render():JSX.Element
    {
        const {
            title,
            bodyText,
            placeholder
        } = this.props;

        return (
            <Dialog
                title={title}
                onClose={this._handleClose}
            >
                <Column className={cx('content')}>

                    {
                        bodyText &&
                        <div className={cx('message')}>
                            {bodyText}
                        </div>
                    }

                    <Input
                        ref={this._handleInputRef}
                        className={cx('input')}
                        placeholder={placeholder}
                        initialValue={this._name}
                        isInitiallyFocused={true}
                        isInitiallySelected={true}
                        style={InputStyle.Dialog}
                        errorPopupSide={ErrorPopupSide.Bottom}
                        isValidFn={this._isValidFn}
                        getErrorMessageFn={this._getErrorMessageFn}
                        onChange={this._handleNameChange}
                        onEnterKey={this._handleSave}
                    />

                    <Row className={styles.buttonsRow}>

                        <DialogButton
                            caption={'Cancel'}
                            intent={MDIntent.Default}
                            style={ButtonStyle.SimpleSecondary}
                            onClick={this._onCancelled}
                            className={styles.cancelBtn}
                        />

                        <DialogButton
                            caption={'Rename'}
                            onClick={this._handleSave}
                            isDisabled={!this._isValidFn(this._name)}
                        />

                    </Row>

                </Column>
            </Dialog>
        );
    }
}
